export default "__VITE_ASSET__BSjagFJ4__"